import "./app.scss";
import { BrowserRouter as Router, Routes,Route} from "react-router-dom";
import Home from "./pages/home/Home";
import Words from "./pages/words/Words";
import Topics from "./pages/topics/Topics";
import Questions from "./pages/questions/Questions";
import NotFound from "./pages/notFound/NotFound";
import ScreenOrientationReact from 'screen-orientation-react'
import { Suspense } from "react";

const App = () => {

  
  const options = { 
    color:  "#ffffff",
    bgColor: "#5b92e5",
    iconColor: "#ffffff",
  }
  return ( <div className="app">
    <Suspense fallback={null}>
      <ScreenOrientationReact options={options}/>
      <Router>
        <Routes>
          <Route exact path="/" element={<Home/>}/>
          <Route path="/palabras" element={<Words/>}/>
          <Route path="/tematica" element={<Topics/>}/>
          <Route path="/preguntas" element={<Questions/>}/>
          <Route path="*" element={<NotFound/>}/>
        </Routes>
      </Router>
      </Suspense>

    </div>
  )
};

export default App;